module.exports = __webpack_public_path__ + "img/productHome4.e3b35989.png";